import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAppStore } from '../../stores/appStore';

export default function MainLayout() {
  const sidebarCollapsed = useAppStore((state) => state.sidebarCollapsed);
  // Full-bleed (no outer padding) for canvas-first pages like the Agent Builder
  // cockpit and the Graph Assistant chat — each owns its own
  // h-[calc(100vh-4rem)] and must sit flush under the 4rem sticky Header. The
  // outer p-8 would otherwise push them 4rem past the viewport, reintroducing a
  // page scrollbar and the boxed-in framing.
  const pathname = useLocation().pathname;
  const fullBleed =
    pathname.startsWith('/agent-builder') || pathname.startsWith('/graph-assistant');

  return (
    <div className="min-h-screen bg-neutral-50">
      <Header />
      <div className="flex">
        <Sidebar />
        <main
          className={`flex-1 min-w-0 overflow-x-clip transition-all duration-300 ${
            sidebarCollapsed ? 'ml-16' : 'ml-64'
          }`}
        >
          <div className={fullBleed ? '' : 'p-8'}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
